"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4592,4491],{

/***/ 87442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EventTracker; }
});

// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 53 modules
var esm = __webpack_require__(76194);
;// CONCATENATED MODULE: ./src/helpers/events/config.ts
var amplitudeDev = "d0baaa67671a694012f8148ca07a6b8c";
var amplitudeProd = "6e3c59bf5fba9aad8e18636004359b65";

// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
;// CONCATENATED MODULE: ./src/helpers/events/EventTracker/init.ts




function init() {
    var amplitudeApiKey = (0,getEnv/* default */.Z)() === "prod" ? amplitudeProd : amplitudeDev;
    try {
        (0,esm/* init */.S1)(amplitudeApiKey);
    } catch (e) {
        logger/* default.error */.Z.error(e);
    }
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/helpers/events/EventTracker/sendEvent.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var sendEventToAnalytics = function(eventType, properties) {
    (0,esm/* track */.j)(eventType, _objectSpread({}, properties));
};
function sendEvent(eventType) {
    return _sendEvent.apply(this, arguments);
};
function _sendEvent() {
    _sendEvent = _asyncToGenerator(runtime_default().mark(function _callee(eventType) {
        var eventProperties, obj, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventProperties = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    try {
                        obj = JSON.parse(JSON.stringify(eventProperties));
                        sendEventToAnalytics(eventType, obj);
                    } catch (error) {
                        logger/* default.error */.Z.error("Failed Amplitude sendEvent", {
                            error: error,
                            eventType: eventType
                        });
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _sendEvent.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/events/EventTracker/setUserId.ts
var setUserId = __webpack_require__(14491);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-core/lib/esm/identify.js
var identify = __webpack_require__(95656);
;// CONCATENATED MODULE: ./src/helpers/events/EventTracker/setUserProperties.ts


var getIdentifyEvent = function(properties) {
    var identifyEvent = new identify/* Identify */.h();
    for(var propertyKey in properties){
        var property = properties[propertyKey];
        identifyEvent.set(propertyKey, property);
    }
    return identifyEvent;
};
function setUserProperties(properties) {
    if (!properties || !Object.keys(properties).length) return;
    try {
        var identifyEvent = getIdentifyEvent(properties);
        (0,esm/* identify */.yV)(identifyEvent);
    } catch (error) {
        logger/* default.error */.Z.error("Failed Amplitud setting User Properties", {
            properties: properties,
            error: error
        });
    }
};

;// CONCATENATED MODULE: ./src/helpers/events/EventTracker/index.ts




var amplitude = {
    init: init,
    sendEvent: sendEvent,
    setUserId: setUserId.setUserId,
    setUserProperties: setUserProperties
};
/* harmony default export */ var EventTracker = (amplitude);


/***/ }),

/***/ 14491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "setUserId": function() { return /* binding */ setUserId; }
/* harmony export */ });
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76194);
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80251);


function setUserId(userId) {
    try {
        (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_1__/* .setUserId */ .Iv)(userId);
    } catch (error) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .Z.error("Failed Amplitude setUserId", {
            error: error
        });
    }
}


/***/ }),

/***/ 34592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WithEvents": function() { return /* binding */ WithEvents; },
/* harmony export */   "default": function() { return /* binding */ useEvents; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _EventTracker__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87442);


function useEvents() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        _EventTracker__WEBPACK_IMPORTED_MODULE_1__/* ["default"].init */ .Z.init();
    }, []);
    return null;
};
var WithEvents = function(param) {
    var children = param.children;
    useEvents();
    return children;
};


/***/ })

}]);